import React, { Component } from 'react';
import * as Sentry from '@sentry/react';
import { AlertCircle, Mail } from 'lucide-react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    console.error('ERROR --', error);
    console.error('INFO --', info);
    Sentry.captureReactException(error, info);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            backgroundColor: '#f9f9f9',
          }}
        >
          <div style={{ maxWidth: '550px', width: '100%', textAlign: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <AlertCircle size={83} color="#d32f2f" style={{ marginBottom: '24px' }} />
            </div>

            <h1
              style={{
                fontSize: '4.5rem',
                fontWeight: '400',
                margin: '0',
                lineHeight: '1.2',
              }}
            >
              500
            </h1>
            <h2
              style={{
                fontSize: '3.5rem',
                fontWeight: '300',
                margin: '0',
                lineHeight: '1.2',
              }}
            >
              Internal Server Error
            </h2>
            <p
              style={{
                fontSize: '1.1rem',
                marginTop: '16px',
                marginBottom: '32px',
                color: '#333',
                lineHeight: '1.6',
              }}
            >
              Oops! Something went wrong on our end. Our team has been notified and we're working to
              fix the issue.
            </p>

            <div
              style={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'center',
                flexWrap: 'wrap',
                marginBottom: '32px',
              }}
            >
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: '10px 24px',
                  fontSize: '14px',
                  fontWeight: '500',
                  backgroundColor: 'rgb(23, 166, 168)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
                className="no-active-or-focus-color"
              >
                Try Again
              </button>

              <button
                onClick={() => {
                  window.location.href = '/';
                }}
                style={{
                  padding: '10px 24px',
                  fontSize: '14px',
                  fontWeight: '500',
                  backgroundColor: 'transparent',
                  color: 'rgb(23, 166, 168)',
                  border: '1px solid rgb(23, 166, 168)',
                  borderRadius: '4px',
                  textDecoration: 'none',
                  display: 'inline-block',
                  cursor: 'pointer',
                }}
                className="no-active-or-focus-color"
              >
                Go Home
              </button>
            </div>

            <div>
              <p
                style={{
                  fontSize: '1.1rem',
                  marginBottom: '8px',
                  color: '#666',
                }}
              >
                If the problem persists, please contact support
              </p>
              <a
                href="mailto:help@heliumapp.com"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  textDecoration: 'none',
                  fontSize: '14px',
                  color: 'rgb(23, 166, 168)',
                  transition: 'color 0.2s ease',
                }}
              >
                <Mail size={16} />
                help@heliumapp.com
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
